// 卡片操作类型枚举
export enum CardActionType {
  CardInfo = 'card-info',
  FreezeUnfreeze = 'freeze-unfreeze',
  LimitAdjustment = 'limit-adjustment',
  Management = 'management'
}

// 卡片操作项接口
export interface CardActionItem {
  icon: string
  title: string
  actionType: CardActionType
}
